// @section 1 Tiny toast for optimistic-UI feedback

import { useEffect, useState } from 'react';

let pushExternal: ((msg: string) => void) | null = null;
export function toast(msg: string) { pushExternal?.(msg); }

export function ToastHost() {
  const [items, setItems] = useState<{ id: number; msg: string }[]>([]);

  useEffect(() => {
    pushExternal = (msg: string) => {
      const id = Date.now() + Math.random();
      setItems((xs) => [...xs, { id, msg }]);
      setTimeout(() => setItems((xs) => xs.filter((x) => x.id !== id)), 2400);
    };
    return () => { pushExternal = null; };
  }, []);

  return (
    <div className="toast-host">
      {items.map((t) => <div key={t.id} className="toast">{t.msg}</div>)}
    </div>
  );
}
